(function() {
  var dtSignalPath = '/products/deutsch-dt2-female-12v-signal-detector';

  function applyDtSignalDetectorPatch() {
    if (window.location.pathname !== dtSignalPath) return;

    var overview = document.querySelector('.pu-product-overview, .pu-te-overview, .product-single__description, .pro-short-desc');
    if (overview && overview.textContent.indexOf('W2S-SDT-24') === -1) {
      var note = document.createElement('div');
      note.className = 'pu-product-note pu-dt-signal-note';
      note.innerHTML = '<strong>Special LED wedgelocks:</strong> Use W2S-SDT-12V for 12 volt detector applications or W2S-SDT-24 for 24 volt detector applications. This detector connector mates with DT04-2P and compatible DT04-2P variants.';
      overview.insertBefore(note, overview.firstChild);
    }

    var roles = document.querySelectorAll('.pu-related-card__role');
    for (var i = 0; i < roles.length; i += 1) {
      if (roles[i].textContent.trim() === 'DT06-2S-SDT-CE28 signal detector wedgelock') {
        roles[i].textContent = '12V LED signal detector wedgelock';
      }
    }

    var groups = document.querySelectorAll('.pu-compatible-group');
    for (var j = 0; j < groups.length; j += 1) {
      var heading = groups[j].querySelector('h3');
      if (!heading || heading.textContent.trim() !== 'Wedgelocks') continue;
      if (groups[j].textContent.indexOf('W2S-SDT-24') !== -1) continue;

      var noteGrid = document.createElement('div');
      noteGrid.className = 'pu-compatible-note-grid';
      noteGrid.innerHTML = '<div class="pu-compatible-note"><strong>24V LED signal detector wedgelock</strong><span>Use W2S-SDT-24 for 24 volt detector applications with this DT06-2S-SDT-CE28 housing.</span></div>';
      groups[j].appendChild(noteGrid);
    }
  }

  function dedupeHardwareProtectionCards() {
    var groups = document.querySelectorAll('.pu-compatible-group');
    for (var i = 0; i < groups.length; i += 1) {
      var heading = groups[i].querySelector('h3');
      if (!heading || heading.textContent.trim() !== 'Hardware & Protection') continue;
      var seen = {};
      var cards = groups[i].querySelectorAll('.pu-related-card');
      for (var j = 0; j < cards.length; j += 1) {
        var skuText = cards[j].querySelector('.pu-related-card__sku');
        var sku = skuText ? skuText.textContent.replace(/^SKU:\s*/i, '').trim() : '';
        if (!sku) continue;
        if (seen[sku]) {
          cards[j].remove();
        } else {
          seen[sku] = true;
        }
      }
    }
  }

  function addMetalMountingClips() {
    var productPath = window.location.pathname || '';
    if (!/^\/products\/deutsch-dt[mp]?/i.test(productPath)) return;

    var section = document.querySelector('.pu-compatible-group[aria-label="Connector accessories"]');
    if (!section || section.querySelector('[data-pu-metal-clip]')) return;

    var grid = section.querySelector('.pu-related-card-grid');
    if (!grid) return;

    var clips = [
      {
        role: 'Steel 03 mounting clip option',
        title: 'DEUSTCH 1027-003-1200 Steel 03 Mounting Clip',
        url: '/products/deustch-1027-003-1200-steel-03-clip',
        image: 'https://cdn.shopify.com/s/files/1/0304/6745/7069/products/TEC-1027-003-1200_01.jpg?v=1589890991',
        sku: 'TEC-1027-003-1200',
        price: '$5.99',
        stock: 'Available',
        available: true,
        variantId: '34418287280173'
      },
      {
        role: 'Steel 05 mounting clip option',
        title: 'DEUTSCH 1027-005-1200 Steel 05 Mounting Clip',
        url: '/products/deutsch-1027-005-1200-steel-05-clip',
        image: 'https://cdn.shopify.com/s/files/1/0304/6745/7069/products/TEC-1027-005-1200_01.jpg?v=1589891039',
        sku: 'TEC-1027-005-1200',
        price: '$5.49',
        stock: 'Contact us',
        available: false,
        variantId: '34418292228141'
      },
      {
        role: 'Steel 08 mounting clip option',
        title: 'DEUTSCH 1027-008-1200 Steel 08 Mounting Clip',
        url: '/products/deutsch-1027-008-1200-steel-08-clip',
        image: 'https://cdn.shopify.com/s/files/1/0304/6745/7069/products/TEC-1027-008-1200_01.jpg?v=1589891041',
        sku: 'TEC-1027-008-1200',
        price: '$3.69',
        stock: 'Contact us',
        available: false,
        variantId: '34418292752429'
      }
    ];

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function cardHtml(clip) {
      var stockClass = clip.available ? 'pu-related-card__stock' : 'pu-related-card__stock pu-related-card__stock--contact';
      var form = clip.available
        ? '<form class="pu-related-card__cart" method="post" action="/cart/add"><input type="hidden" name="id" value="' + escapeHtml(clip.variantId) + '"><input type="hidden" name="quantity" value="1"><button class="pu-related-card__add" type="submit">Add to cart</button></form>'
        : '';
      return '<article class="pu-related-card pu-related-card--metal-clip" data-pu-metal-clip="' + escapeHtml(clip.sku) + '">' +
        '<a class="pu-related-card__media" href="' + escapeHtml(clip.url) + '" aria-label="' + escapeHtml(clip.title) + '">' +
        '<img src="' + escapeHtml(clip.image) + '" alt="' + escapeHtml(clip.title) + '" loading="lazy">' +
        '</a>' +
        '<div class="pu-related-card__body">' +
        '<span class="pu-related-card__role">' + escapeHtml(clip.role) + '</span>' +
        '<a class="pu-related-card__title" href="' + escapeHtml(clip.url) + '">' + escapeHtml(clip.title) + '</a>' +
        '<span class="pu-related-card__sku">SKU: ' + escapeHtml(clip.sku) + '</span>' +
        '<div class="pu-related-card__meta"><span class="pu-related-card__price">' + escapeHtml(clip.price) + '</span><span class="' + stockClass + '">' + escapeHtml(clip.stock) + '</span></div>' +
        form +
        '<a class="pu-related-card__cta" href="' + escapeHtml(clip.url) + '">View item</a>' +
        '</div>' +
        '</article>';
    }

    grid.insertAdjacentHTML('beforeend', clips.map(cardHtml).join(''));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      dedupeHardwareProtectionCards();
      applyDtSignalDetectorPatch();
      addMetalMountingClips();
    });
  } else {
    dedupeHardwareProtectionCards();
    applyDtSignalDetectorPatch();
    addMetalMountingClips();
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest && event.target.closest('[data-pu-tab-target], .pu-te-nav a, [role="tab"]')) {
      window.setTimeout(dedupeHardwareProtectionCards, 50);
      window.setTimeout(dedupeHardwareProtectionCards, 350);
      window.setTimeout(applyDtSignalDetectorPatch, 60);
      window.setTimeout(applyDtSignalDetectorPatch, 360);
      window.setTimeout(addMetalMountingClips, 80);
      window.setTimeout(addMetalMountingClips, 380);
    }
  }, true);

  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('[data-pu-helper-tab-target]');
    if (!button) {
      return;
    }

    var layout = button.closest('.pu-product-layout--connector') || document;
    var targetId = button.getAttribute('data-pu-helper-tab-target');
    var sectionType = button.getAttribute('data-pu-helper-section') || '';
    var tab = layout.querySelector('[data-pu-tab-target="' + targetId + '"]');
    var panel = document.getElementById(targetId);

    event.preventDefault();

    if (tab && panel) {
      var tabs = layout.querySelectorAll('[data-pu-tab-target]');
      var panels = layout.querySelectorAll('.pu-product-panel');

      tabs.forEach(function(item) {
        var isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function(item) {
        var isActive = item === panel;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });
    }

    window.setTimeout(function() {
      var section = findHelperSection(panel, sectionType) || panel;
      if (section && section.scrollIntoView) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 80);
  }, true);

  function findHelperSection(panel, sectionType) {
    if (!panel) {
      return null;
    }

    var labels = {
      mating: ['mating connector', 'mating connector side', 'mating side', 'used with housings', 'housings used'],
      wedgelock: ['wedgelocks', 'wedgelock', 'secondary locks'],
      contacts: ['terminals and contacts', 'contacts', 'pins', 'sockets'],
      accessories: ['connector accessories', 'mounting hardware and protection', 'hardware and protection', 'accessories'],
      tools: ['application tooling', 'deutsch application tooling']
    };
    var needles = labels[sectionType] || [];
    var groups = panel.querySelectorAll('.pu-compatible-group');

    for (var i = 0; i < groups.length; i += 1) {
      var label = (groups[i].getAttribute('aria-label') || '').toLowerCase();
      var headingNode = groups[i].querySelector('h3');
      var heading = (headingNode ? headingNode.textContent : '').toLowerCase();

      for (var j = 0; j < needles.length; j += 1) {
        if (label.indexOf(needles[j]) !== -1 || heading.indexOf(needles[j]) !== -1) {
          return groups[i];
        }
      }
    }

    return null;
  }

  window.setTimeout(dedupeHardwareProtectionCards, 1000);
  window.setTimeout(dedupeHardwareProtectionCards, 2500);
  window.setTimeout(dedupeHardwareProtectionCards, 5000);
  window.setTimeout(applyDtSignalDetectorPatch, 1000);
  window.setTimeout(applyDtSignalDetectorPatch, 2500);
  window.setTimeout(applyDtSignalDetectorPatch, 5000);
  window.setTimeout(addMetalMountingClips, 1000);
  window.setTimeout(addMetalMountingClips, 2500);
  window.setTimeout(addMetalMountingClips, 5000);
})();
